import { _ as _defineProperty } from '../_chunks/dep-66374d0e.js';
import Vue from 'vue';
import props from './props/props.js';
import useSizeProps from '../utils/use-size-props.js';
import ConfigContext from '../utils/config-context.js';
import { checkLinkAndLoad } from '../utils/check-url-and-load.js';
import '../style/css.js';
import '../utils/use-common-classname.js';

var classPrefix = ConfigContext.classPrefix;
var CDN_ICONFONT_URL = "https://tdesign.gtimg.com/icon/0.2.0/fonts/index.css";
var IconFont = Vue.extend({
  name: "IconFont",
  props: props,
  computed: {
    isBuiltinIcon: function isBuiltinIcon() {
      return this.url && /^t-icon-(\w|-)+$/.test(this.name);
    },
    classes: function classes() {
      var _ref;
      var tName = "".concat(classPrefix, "-icon");
      var _useSizeProps = useSizeProps(this.size),
        sizeClassName = _useSizeProps.className;
      var arr = [(_ref = {}, _defineProperty(_ref, this.name, this.url), _defineProperty(_ref, tName, !this.url || this.isBuiltinIcon), _defineProperty(_ref, "".concat(tName, "-").concat(this.name), !this.url), _ref), sizeClassName];
      return arr;
    },
    iconStyle: function iconStyle() {
      if (["small", "medium", "large"].includes(this.size)) return {};
      return {
        "font-size": this.size
      };
    }
  },
  mounted: function mounted() {
    var finalUrl = [];
    if (this.url) {
      finalUrl = this.url instanceof Array ? this.url.concat() : [this.url];
    }
    if (this.loadDefaultIcons) {
      finalUrl.push(CDN_ICONFONT_URL);
    }
    Array.from(new Set(finalUrl)).forEach(function (url) {
      checkLinkAndLoad(url, "".concat(classPrefix, "-iconfont-stylesheet--unique-class"));
    });
  },
  methods: {
    handleClick: function handleClick(e) {
      var _this$onClick;
      this.$emit("click", {
        e: e
      });
      (_this$onClick = this.onClick) === null || _this$onClick === void 0 ? void 0 : _this$onClick.call(this, {
        e: e
      });
    }
  },
  render: function render() {
    var h = arguments[0];
    var Component = this.tag;
    return h(Component, {
      "class": this.classes,
      "style": this.iconStyle,
      "on": {
        "click": this.handleClick
      }
    });
  }
});

export default IconFont;
export { IconFont };
//# sourceMappingURL=icon.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-icons-vue/esm/iconfont/icon.js
// module id = null
// module chunks = 